import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

// Генеруємо версію для обходу кешу (використовуємо timestamp при збірці)
const CACHE_BUSTER = process.env.REACT_APP_BUILD_TIME || Date.now().toString();

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['uk'], // Залишаємо тільки українську
    fallbackLng: 'uk',     // Мова за замовчуванням
    debug: false,
    
    react: {
      useSuspense: true,
    },

    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${CACHE_BUSTER}`,
      reloadInterval: false,
    },
    
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    },
  });

export default i18n;